<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary border-primary px-3 text-light">
        <h5 class="modal-title">OnPlan WebUI</h5>
      </div>
      <div class="modal-body bg-dark text-white p-3">
        <form class="d-flex flex-column align-items-end justify-contents-center">
          <p class="lead fs-5 w-100">
            Please login to continue <i class="bi bi-info-circle float-end"></i>
          </p>
          <div class="row mb-3 w-100">
            <label for="inputEmail" class="col-sm-2 col-form-label">Email</label>
            <div class="col-sm-10">
              <input type="email" class="form-control" name="email" [(ngModel)]="email">
            </div>
          </div>
          <div class="row mb-3 w-100">
            <label for="inputPassword" class="col-sm-2 col-form-label">Password</label>
            <div class="col-sm-10">
              <input type="password" class="form-control" id="inputPassword" name="password" [(ngModel)]="password">
            </div>
          </div>
          <div class="d-flex align-items-center justify-contents-end gap-2">
            <button type="button" class="btn btn-info" (click)="resetPassword()">Reset Password</button>
            <button type="button" class="btn btn-primary" (click)="login()">Sign in</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>